import React from "react";
import GridBoxComponent from "./GridBoxComponent";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import { Spin } from "antd";
import SearchComponent from "./SearchComponent";
import style from "../style";
import TableComponent from "./TableComponent";
import { useRequisitionBranchContext } from "../context";

const PageHealthyMe = () => {
  const { state } = useRequisitionBranchContext();
  return (
    <Spin spinning={state.loading}>
      <Panel>
        <PanelHeader>ข้อมูลHealthy Me โค้ด</PanelHeader>
        <PanelBody>
          <div style={style.body_space}>
            <GridBoxComponent />
            <SearchComponent />
            <div style={style.divid_y} />
            <TableComponent />
          </div>
        </PanelBody>
      </Panel>
    </Spin>
  );
};

export default PageHealthyMe;
